import { render, staticRenderFns } from "./RefillProductsModule.vue?vue&type=template&id=41c10f38&scoped=true"
import script from "./RefillProductsModule.vue?vue&type=script&lang=js"
export * from "./RefillProductsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c10f38",
  null
  
)

export default component.exports